import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../components/Modal';
import Select from '../../../../components/Select';
import RadioGroup, { Radio } from '../../../../components/RadioGroup';
import { getCustomers } from '../../../../redux/customer';

import Breadcrumb from './Breadcrumb';
import Form from './Form';

// map

const filters = {
  ALL: 'ALL',
  KEY_ACCOUNTS: 'KEY_ACCOUNTS',
  CUSTOM: 'CUSTOM',
};

class DashboardCompletedFilterCustomerModal extends Component {

  state = {
    value: this.props.selectedCustomers || [],
    isCustom: this.props.selectedCustomers.length > 0,
    selectedFilter: this.props.isOnlyKeyAccounts ?
      filters.KEY_ACCOUNTS :
      (this.props.selectedCustomers.length > 0 ? filters.CUSTOM : filters.ALL),
  }

  componentDidMount() {
    if (!this.props.minimumDigits) {
      this.props.dispatch(getCustomers());
    }
  }

  _changeFilter = (type) => {
    const { onApply } = this.props;

    if (type === filters.KEY_ACCOUNTS) {
      onApply([], 's');
    } else if (type === filters.CUSTOM) {
      this.setState({ isCustom: true });
    } else { // ALL
      onApply([]);
    }
  }

  _handleOnIputChange = (value) => {
    if (this.props.minimumDigits && value.length >= this.props.minimumDigits) {
      this.props.dispatch(getCustomers(value));
    }
  }

  _handleChange = (value) => {
    this.setState({
      value: value.map(v => v.value),
    });
  }

  _submit = () => {
    this.props.onApply(this.state.value);
  }

  _mapListToOptions = () => this.props.customersList.map(customer => ({
    value: customer.cd_CGCCPF,
    label: customer.ds_RazaoSocial,
  }))

  _goBack = () => this.setState({ isCustom: false })

  _renderContent = () => {
    const { isCustom, selectedFilter } = this.state;

    if (isCustom) {
      return (
        <div>
          <Breadcrumb
            onBack={this._goBack}
            prev="Todos os filtros"
            current="Selecionar clientes"
          />
          <Form
            onSubmit={this._submit}
            submitText="Aplicar"
          >
            <Select
              onInputChange={this._handleOnIputChange}
              options={this._mapListToOptions()}
              value={this.state.value}
              onChange={this._handleChange}
              closeOnSelect={false}
              multi
            />
          </Form>
        </div>
      )
    }

    return (
      <RadioGroup
        value={selectedFilter}
        onChangeValue={this._changeFilter}
      >
        <Radio
          value={filters.ALL}
          label="Todos os clientes"
        />
        <Radio
          value={filters.KEY_ACCOUNTS}
          label="Apenas key accounts"
          renderRight={() => (
            <span className="icon icon-star" />
          )}
        />
        <Radio
          value={filters.CUSTOM}
          label="Selecionar clientes"
        />
      </RadioGroup>
    );
  };

  render() {
    return (
      <Modal
        title="Selecionar clientes"
        size="small"
        onBackdropClick={this.props.onBackdropClick}
      >
        {this._renderContent()}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  customersList: state.customer.list,
});

export default connect(mapStateToProps)(DashboardCompletedFilterCustomerModal)
